import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './services/user.service';

@Injectable({
    providedIn: 'root'
})

export class AuthGuard implements CanActivate {

    constructor(
        private user: UserService,
        private router: Router
    ) {
        // console.log('In Auth Guard...');
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {

        if ( this.user.status != 0 ) {
            return true;
        } else {
            // console.log('Unauthorized User!');
            this.router.navigate(['']);
            return false;
        }
    }
}
